import { BdsIcon, BdsTooltip, BdsTypo } from 'blip-ds/dist/blip-ds-react';
import React, { useContext, useMemo } from 'react';
import { BlipProgressBar } from '../../../components/BlipProgressBar';
import DailyEngagedUsersContext from '../../../contexts/DailyEngagedUsersContext';
import {
  CompiledDailyEngagedUsersOverspentProgressContent,
  DailyEngagedUsersProgressBarAligned,
  DailyEngagedUsersProgressTotalAligned,
} from '../styles';
import blipColors from 'blip-tokens/build/json/colors.json';

const CompiledDailyEngagedUserProgressContentComponent: React.FC = () => {
  const { content, compiledDailyEngagedUserDataState, currentMonth } = useContext(DailyEngagedUsersContext);

  const NO_PERCENTAGE_LABEL = '0%';

  const spentPercentage = useMemo(() => {
    if (compiledDailyEngagedUserDataState.compiledContainsDataOnSelectedMonth) {
      return content.formatString(
        content.compiledDailyEngagedUserInformation.spentPercentage,
        compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.planUsageRate,
      );
    } else {
      return NO_PERCENTAGE_LABEL;
    }
  }, [compiledDailyEngagedUserDataState]);

  const planUsage = (toLocaleString: boolean) => {
    if (compiledDailyEngagedUserDataState.compiledContainsDataOnSelectedMonth) {
      return toLocaleString
        ? compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.planUsage.toLocaleString()
        : compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.planUsage;
    } else {
      return '--';
    }
  };

  const quantity = (toLocaleString: boolean) => {
    if (compiledDailyEngagedUserDataState.compiledContainsDataOnSelectedMonth) {
      return toLocaleString
        ? compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.metric.quantity.toLocaleString(
          content.locale,
        )
        : compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.metric.quantity;
    } else {
      return '--';
    }
  };

  const planUsageRate = compiledDailyEngagedUserDataState.compiledContainsDataOnSelectedMonth
    ? compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption.planUsageRate
    : 0;

  return (
    <CompiledDailyEngagedUsersOverspentProgressContent
      containsOverspent={compiledDailyEngagedUserDataState.compiledContainsDataOnSelectedMonth}
      currentMonth={currentMonth}
    >
      <DailyEngagedUsersProgressBarAligned>
        <BdsTypo data-planUsageRate={planUsageRate} tag="span" variant="fs-16" bold="bold" margin={false}>
          {spentPercentage}
        </BdsTypo>
        <BdsTooltip
          position="top-center"
          tooltip-text={content.compiledDailyEngagedUserInformation.progressContentHoverIcon}
        >
          <BdsIcon name="info"></BdsIcon>
        </BdsTooltip>
        <BlipProgressBar
          completed={planUsageRate}
          color={currentMonth ? blipColors['color-primary-oranges-carrot'] : blipColors['color-primary-main']}
        ></BlipProgressBar>
      </DailyEngagedUsersProgressBarAligned>

      <DailyEngagedUsersProgressTotalAligned currentMonth={currentMonth}>
        <BdsTypo className="highlighted" data-planUsage={planUsage(false)} variant="fs-32" tag="span" bold="extra-bold" margin={false}>
          {planUsage(true)}
        </BdsTypo>
        <BdsTypo className="total-dau" variant="fs-32" tag="span" bold="extra-bold">
          /
        </BdsTypo>
        <BdsTypo data-quantity={quantity(false)} variant="fs-24" tag="span" bold="extra-bold" margin={false}>
          {quantity(true)}
        </BdsTypo>
      </DailyEngagedUsersProgressTotalAligned>
    </CompiledDailyEngagedUsersOverspentProgressContent>
  );
};

export default CompiledDailyEngagedUserProgressContentComponent;
